import Route from "@ember/routing/route";
import { service } from "@ember/service";
import type Store from "@ember-data/store";
import { findRecord } from "@warp-drive/legacy/compat/builders";
import type Database from "glesys-controlpanel/models/database";
import type DataCenter from "glesys-controlpanel/models/data-center";
import type Project from "glesys-controlpanel/models/project";

export interface DatabaseDetailsRouteModel {
  database: Database;
  dataCenters: DataCenter[];
  project: Project;
}

export default class DatabasesDetailsRoute extends Route {
  @service declare store: Store;

  async model(params: { database_id: string }): Promise<DatabaseDetailsRouteModel> {
    const { project } = this.modelFor("organization") as { project: Project };
    const dataCenters = this.store.peekAll<DataCenter>("data-center");
    const { content: database } = await this.store.request(
      findRecord<Database>("database", params.database_id, { reload: true }),
    );

    return {
      database,
      dataCenters,
      project,
    };
  }
}
